import Form from "../../common/Form/Form";
import DualButton from "../../common/DualButton";
import "./style.css";
import BigDaddyFitnessHeader from "./BigDaddyFitnessHeader";

import jsonDataEn from "./data-en.json";
import jsonDataFr from "./data-fr.json";
import { useContext } from "react";
import LanguageContext from "../../../context/LanguageContext";

const BigDaddyFitnessMain = () => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data : jsonDataFr.data;

  return (
    <div className="bigdaddyfitness">
      <BigDaddyFitnessHeader />
      <Form banner={data.banner} footer={data.footerTextLine1} gymName="bigdaddyfitness" gymID={2} button={<DualButton recipient={"info@bigdaddyfitness.com"} />} />
    </div>
  );
};

export default BigDaddyFitnessMain;
